import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  collapseWrapper: {
    padding: '16px 24px'
  },
  collapseChildren: {
    padding: '16px 24px',
    paddingTop: 0
  },
  column: {
    minWidth: 260
  },
  columnFullWidth: {
    minWidth: 260,
    width: '100%'
  },
  reactionCard: {
    padding: '16px 24px',
    marginBottom: 16
  },
  collapseHeader: {
    '.ant-collapse-item .ant-collapse-header': {
      backgroundColor: `${token.colorWhite} !important`,
      height: 'auto !Important',
      borderRadius: '8px !important'
    },
    '.ant-collapse-item:last-child': {
      borderRadius: '8px !important'
    }
  },
  collapseHeaderMargin: {
    marginBottom: 16,
    border: `1px solid ${token.colorSplit} !important`,
    borderRadius: 8
  },
  tagsWrapper: {
    marginTop: 16
  },
  dropdownRender: {
    padding: 4
  },
  tags: {
    borderRadius: 16,
    padding: '4px 10px 4px 12px',
    color: token.primary.primary1,
    backgroundColor: token.blue1,
    border: 'none',
    '.ant-tag-close-icon': {
      color: token.primary.primary1
    }
  },
  adverseField: {
    minWidth: 280,
    maxWidth: 280
  }
}))
